<template>
  <div class="BioDetail main_style">
    <Main_nav />
    <searchBar />
    <div class="responsive-layout mx-auto">
      <b-row class="justify-content-end mt-3">
        <b-col md="2" cols="6">
          <button
            @click="communityDetail"
            v-if="
              accessToken &&
              user.user.group_id == 5 &&
              user.user.community_id == $route.params.id
            "
            class="btn shadow orange-background pill"
          >
            แก้ไข
          </button>
        </b-col>
      </b-row>
      <b-row class="text-left mt-3 mx-3 ml-xl-5">
        <b-col
          v-for="(item, index) in selectComunity.image_url"
          :key="index"
          md="2"
          sm="6"
          cols="12"
        >
          <img class="img-fluid mb-2" v-img :src="item" />
        </b-col>
      </b-row>
      <b-row class="text-left mt-3 mx-3 ml-xl-5">
        <b-col>
          <h4>{{ selectComunity.name }}</h4>
        </b-col>
      </b-row>
      <b-row class="text-left mt-3 mx-3 ml-xl-5">
        <b-col class="green-text" md="2" sm="12" cols="12"> ที่ตั้ง : </b-col>
        <b-col md="9" cols="10"
          >{{ selectComunity.address }} ตำบล{{
            selectComunity.subdistrict ? selectComunity.subdistrict.name : null
          }}
          อำเภอ{{
            selectComunity.district ? selectComunity.district.name : null
          }}
          {{
            selectComunity.province ? selectComunity.province.name : null
          }}</b-col
        >
      </b-row>
      <b-row class="text-left mt-3 mx-3 ml-xl-5">
        <b-col class="green-text" md="2" sm="12" cols="12"
          >รายละเอียดชุมชน :</b-col
        >
        <b-col md="9" cols="10">{{ selectComunity.description }}</b-col>
      </b-row>
      <b-row class="text-left my-3 mx-3 ml-xl-5">
        <b-col class="green-text" md="2" sm="12" cols="12"
          >ทรัพยากรชีวภาพในท้องถิ่น :</b-col
        >
        <b-col md="9" cols="10">{{ selectComunity.resource }}</b-col>
      </b-row>
      <div v-if="accessToken">
        <b-row
          v-for="item in selectComunity.progress"
          :key="item.id"
          class="text-left my-3 mx-3 ml-xl-5"
        >
          <b-col>
            <b-card class="shadow">
              <div class="d-flex justify-content-between align-items-center">
                <div>ความก้าวหน้าปี {{ item.date }}</div>
                <div>
                  <b-button
                    style="min-width: 150px"
                    v-if="
                      item.attached_file &&
                      (user.group_id == 1 ||
                        user.group_id == 2 ||
                        user.user.community_id == selectComunity.community_id)
                    "
                    class="btn green-background"
                    @click="downloadFile(item.attached_file)"
                    pill
                  >
                    ดาวน์โหลด
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Main_nav from "@/components/navbar";
import searchBar from "@/components/searchBar";
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "CommunityDetail",
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
      selectComunity: (state) => state.communityModule.select_comunity,
      user: (state) => state.AuthModule.userData,
    }),
  },
  data() {
    return {
      modalShow: false,
      community: {
        name: "วิสาหกิจชุมชนพัฒนาผลิตภัณฑ์ทรัพยากรชีวภาพเพื่อเศรษฐกิจชุมชน บ้านวังส้มซ่า ตำบลท่าโพธิ์ อำเภอเมือง จังหวัดพิษณุโลก",
        address:
          "เลขที่ 30 ซอย บ้านคุ้งวัง 1/4 ตำบล ท่าโพธิ์ อำเภอเมืองพิษณุโลก พิษณุโลก 65000",
        advantage:
          "วิสาหกิจชุมชนพัฒนาผลิตภัณฑ์ทรัพยากรชีวภาพเพื่อเศรษฐกิจชุมชน บ้านวังส้มซ่า ตำบลท่าโพธิ์ อำเภอเมือง จังหวัดพิษณุโลก วิสาหกิจชุมชนพัฒ นาผลิตภัณฑ์ทรัพยากรชีวภาพเพื่อเศรษฐกิจชุมชน บ้านวังส้มซ่า ตำบลท่าโพธิ์ อำเภอเมือง จังหวัดพิษณุโลกวิสาหกิจชุมชนพัฒนาผลิตภัณฑ์ทรัพ ยากรชีวภาพ เพื่อเศรษฐกิจชุมชน บ้านวังส้มซ่า ตำบลท่าโพธิ์ อำเภอเมือง จังหวัดพิษณุโลก",
        progress: [
          { id: 1, year: 2020, amount: 52, hasFile: true },
          { id: 2, year: 2021, amount: 19, hasFile: false },
        ],
        image: [1, 2, 3, 4, 5],
      },
    };
  },
  methods: {
    downloadFile(link) {
      window.open(link, "_blank");
    },
    communityDetail() {
      this.$router.push("/CommunityEdit");
    },
  },
  created() {
    Swal.fire({
      title: "ระบบกำลังทำงาน",
      html: "โปรดรอสักครู่...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        this.$store
          .dispatch("communityModule/onGetCommunity", {
            community_id: this.$route.params.id,
            is_count: 1,
          })
          .then((res) => {
            if (res == 200) {
              Swal.clickConfirm();
            } else {
              Swal.clickConfirm();
            }
          });
      },
    });
  },
  components: {
    Main_nav,
    searchBar,
  },
};
</script>

<style scoped></style>
